import React from 'react';

interface StadiumPlaceholderProps {
  /** Ширина в px; высота выводится из пропорции картинки (6:5). */
  width?: number;
  className?: string;
}

const STADIUM_PLACEHOLDER_URL = '/images/stadium-placeholder.png';
/** Пропорция исходной картинки 180×150. */
const ASPECT_RATIO = 5 / 6;

/**
 * Заглушка локации без фото: стадион с камерой.
 *
 * Рисуется внутри обёртки точного размера — у аватара строки списка на любом `img` стоит
 * `object-fit: cover` на всю площадку 60×60, и голая картинка 6:5 обрезалась бы по бокам.
 */
function StadiumPlaceholder({ width = 60, className }: StadiumPlaceholderProps) {
  return (
    <div className={className} style={{ width, height: Math.round(width * ASPECT_RATIO), flexShrink: 0 }}>
      <img src={STADIUM_PLACEHOLDER_URL} alt="" style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }} />
    </div>
  );
}

export default StadiumPlaceholder;
